import React, { PureComponent } from 'react'
import styledComponents from 'styled-components'
import { selectMovies } from '../../features/movies/MovieSlice'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

export default function Movies() {

    const movies = useSelector(selectMovies);
   

    return (
        <Container>
            <h4>Recommended for You</h4>
            <Content>
                {movies &&
                    movies.map((movie) => (
                        <Wrap key={movie.id}>
                            <Link to={`/details/${movie.id}`}>
                            <img src={movie.cardImg} />
                            </Link>
                         </Wrap>
                    ))
                }



            </Content>
        </Container>
    )

}
const Container = styledComponents.div`
margin-bottom:20px;
`

const Content = styledComponents.div`
display: grid;
grid-gap: 25px;

grid-template-columns: repeat(4, minmax(0,1fr));

`
const Wrap = styledComponents.div`
border-radius: 10px;

cursor:pointer;
border: 3px solid rgba(249,249,249,0.1);
box-shadow: rgba(0 0 0 / 69%) 0px 26px 30px -10px,
rgb(0 0 0 / 73%) 0px 16px 10px -10px;
transition: all 250ms cubic-bezier(0.25,0.46,.45,.94) 0s;
img{
    width:100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
}

&:hover{
    box-shadow: rgba(0 0 0 / 80%) 0px 40px 58px -16px,
    rgb(0 0 0 / 73%) 0px 30px 22px -10px;
    transform: scale(1.05);
    border-color: rgba(249,249,249,0.8);
   
}
` 